<template>
  <el-menu
    :router="router"
    :default-active="activeIndex"
    class="el-menu-demo"
    mode="horizontal"
    :ellipsis="false"
    @select="handleSelect"
    text-color = "#FFFFFF"
    active-text-color="#FFFFFF"
    background-color="#494A4B"
    style="border-bottom: 0px solid;box-shadow: 0 2px 6px 1px; background-color: rgba(0, 0, 0, 0.5); "
  >
    <el-menu-item index="/">
      <img
        style="width: 100px"
        src="../../assets/img/logo.png"
        alt="Element logo"
      />
    </el-menu-item>
    <div class="flex-grow" />
    <el-menu-item index="/" >
      <el-icon><HomeFilled /></el-icon>
            首页
    </el-menu-item>
    <el-menu-item index="3">
      <el-icon><List /></el-icon>
            分类
    </el-menu-item>
    <el-menu-item index="4">
      <el-icon><Tools /></el-icon>
            工具
    </el-menu-item>
    <el-menu-item index="/PhotoLibrary">
      <el-icon><PictureFilled /></el-icon>
            图库
    </el-menu-item>
    <el-menu-item index="8">
      <el-icon><VideoCameraFilled /></el-icon>
            视频
    </el-menu-item>
    <el-menu-item index="9">
      <el-icon><BellFilled /></el-icon>
            歌单
    </el-menu-item>
    <el-menu-item index="6">
      <el-icon><Comment /></el-icon>
            公告
    </el-menu-item>
    <el-menu-item index="7">
      <el-icon><Promotion /></el-icon>
            友链
    </el-menu-item>
    <div class="flex-grow" />
    <el-sub-menu index="5">
      <template #title>登录</template>
      <el-menu-item index="5-1">item one</el-menu-item>
      <el-menu-item index="5-2">item two</el-menu-item>
      <el-menu-item index="5-3">item three</el-menu-item>
    </el-sub-menu>
  </el-menu>
</template>
  
  <script>
import { ref } from "vue";
export default {
  components: {  },
  setup() {
    const activeIndex = ref("1");
    const router = ref(true);
    const handleSelect = (key, keyPath) => {
      console.log(key);
      console.log(keyPath);
    };
    return {
      activeIndex,
      handleSelect,
      router
    };
  },
};
</script>
  
  <style scoped>
.flex-grow {
  flex-grow: 1;
}
.el-menu-item {
  font-size: 20px;
}

.el-menu-demo{
  border-bottom: 0px solid;
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(4px) saturate(180%);
}

:deep(.el-sub-menu__title) {
  font-size: 20px;
}
</style>